import { useState } from 'react';
import { TextField } from '@trukt/ui/TextField';
import { ReportNameFormProps } from './ReportNameForm.types';

export const ReportNameForm = ({ initialState, onSubmit }: ReportNameFormProps) => {
  const [reportName, setReportName] = useState(initialState);
  return (
    <div>
      <TextField
        autoFocus
        value={reportName}
        onChange={(e) => setReportName(e.target.value)}
        onBlur={() => onSubmit(reportName)}
      />
    </div>
  );
};
